import { Routes, Route } from 'react-router-dom';
import { Welcome } from './components/welcome/Welcome';
import { 
  AccountType,
  StudentLoginType,
  ParentLoginType,
  TeacherLoginType
} from './pages/login';
import { AccountSetup } from './pages/signup/accountsettings/AccountSetup';
import { StudentBlue } from './pages/signup/student/StudentBlue';
import { StudentGreen } from './pages/signup/student/StudentGreen';
import { StudentSquare } from './pages/signup/student/StudentSquare';
import { Dashboard } from './pages/dashboard/Dashboard';
import { FactorDetective } from './pages/games/FactorDetective/FactorDetective';
import { MoneyManager } from './pages/games/MoneyManager/MoneyManager';
import { AlgebraAdventures } from './pages/games/AlgebraAdventures/AlgebraAdventures';
import { MeasureMaster } from './pages/games/MeasureMaster/MeasureMaster';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Welcome />} />
      <Route path="/login/account-type" element={<AccountType />} />
      <Route path="/login/student" element={<StudentLoginType />} />
      <Route path="/login/parent" element={<ParentLoginType />} />
      <Route path="/login/teacher" element={<TeacherLoginType />} />
      <Route path="/signup/account-setup" element={<AccountSetup />} />
      <Route path="/signup/student-circle" element={<StudentBlue />} />
      <Route path="/signup/student-triangle" element={<StudentGreen />} />
      <Route path="/signup/student-square" element={<StudentSquare />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/games/factor-detective" element={<FactorDetective />} />
      <Route path="/games/money-manager" element={<MoneyManager />} />
      <Route path="/games/algebra-adventures" element={<AlgebraAdventures />} />
      <Route path="/games/measure-master" element={<MeasureMaster />} />
    </Routes>
  );
}

export default App;